/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box, Text } from '@tishman/components';
import { H } from '@hzdg/sectioning';
import { navigate } from 'gatsby';
import React, { useMemo } from 'react';

// import { useSaleQuery } from '../../../services/odt';

import { ContinueButton } from '..';
import { useAppSelector, selectCityPassBooklet } from '../../../store';
import { useI18n } from '../../../utils';

interface IntroProps {
  description?: string;
  title?: string;
}
export const RedemptionIntro = ({
  description,
  title,
}: IntroProps): JSX.Element => {
  const cityPassBooklet = useAppSelector(selectCityPassBooklet);
  const { t } = useI18n();

  const barcodes = useMemo(
    () => (cityPassBooklet ?? []).map(({ voucherCode }) => voucherCode),
    [cityPassBooklet],
  );

  return (
    <Box>
      <H
        sx={{
          maxWidth: [198, null, 385],
          mb: 3,
          variant: 'text.buyTicketsConfirmationTitle',
        }}
      >
        {title}
      </H>
      <Text
        sx={{
          lineHeight: 'body',
          fontSize: 5,
          maxWidth: 380,
          mb: 2,
          letterSpacing: 1,
        }}
      >
        {description}
      </Text>
      {cityPassBooklet?.length && (
        <Box sx={{ mt: 3, maxWidth: 407 }}>
          <Text sx={{ mb: 3 }}>{t('citypass_redemption')}</Text>
          <ContinueButton
            onClick={() =>
              navigate(
                `/buy-tickets/citypass-redemption?barcodes=${barcodes.join(
                  ',',
                )}`,
              )
            }
            sx={{ width: '100%', mt: 3 }}
            title={t('redeem_now')}
          />
        </Box>
      )}
      <Box sx={{ mt: 4, mb: 3 }}>
        <Text sx={{ variant: 'text.smallP' }}>{t('sale_ticket_text')}</Text>
        {barcodes.map((barcode) => (
          <Text key={barcode} sx={{ variant: 'text.ticketPrice', my: 2 }}>
            {barcode}
          </Text>
        ))}
      </Box>
    </Box>
  );
};
